import ModalWrapper from "@mnjsplatform/components/lib/common/modalWrapper";
import React, {useEffect, useRef} from "react";
import classes from "../AnnualRemuneration.module.css"
import PropTypes from "prop-types";

function useOutsideClickHandler(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target) && typeof(callback) === "function") {
                callback();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}


export const popupArDetailsTypes = {
    histVac: "HistVac",
    histSalCh: "HistSalCh",
    histFix: "HistFix"
}

const contextMenuItems = [
    { title: "ARGridContextMenu_1", type: popupArDetailsTypes.histVac, access: "CanShow_HistVacForm" },
    { title: "ARGridContextMenu_2", type: popupArDetailsTypes.histSalCh, access: "CanShow_HistSalChForm|CanShow_HistFixForm" },
    { title: "ARDetails_5", type:popupArDetailsTypes.histFix, access: "CanShow_YBDetailForm" }
];

const ARGridContextMenu = ({top, left, row, onOpenDetails, onClose}) => {

    const style = {
        top: top,
        left: left
    };

    const rowKey = {SalaryChangeIntId: row.SalaryChangeIntId, OrgStructIntId: row.OrgStructIntId};
    const name = row.OrgStructName;
    const access = row.access;

    const wrapperRef = useRef(null);
    useOutsideClickHandler(wrapperRef, onClose);

    if(row.OrgStructTypeIntId !== 4) {
        return null;
    }

    const showDetails = (type) => {
        onOpenDetails(type, rowKey, name, row.OrgStructId, row.access);
    }

    return (
        <>
            <ModalWrapper>
                <div className={classes.contextMenu} style={style} ref={wrapperRef}>
                    <div className={classes.contextMenu_Title}>{name}</div>
                    {contextMenuItems.map(item => {
                        let hasAccess = false;
                        const accessList = item.access.split('|');
                        for (let index in accessList) {
                            const accessFieldName = accessList[index];
                            hasAccess = hasAccess || access[accessFieldName];
                        }
                        if (!hasAccess) return null;
                        return (
                            <div key={item.type} className={classes.contextMenu_Item}
                                 onClick={() => showDetails(item.type, rowKey)}>{item.title}</div>
                        );
                    })}
                </div>
            </ModalWrapper>

        </>
    );
}

ARGridContextMenu.propTypes = {
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    row: PropTypes.object.isRequired,
    onOpenDetails: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export { ARGridContextMenu };